import { helpers } from "./helpers.ts";
import i18n from "./i18n.ts";

export type SeasonRecord = {
  lost?: number;
  otl?: number;
  tied?: number;
  won?: number;
};

export const getSeasonRecordGamesPlayed = ({ lost, otl, tied, won }: SeasonRecord) =>
  (won ?? 0) + (lost ?? 0) + (otl ?? 0) + (tied ?? 0);

// A bare "0-0" is ambiguous outside a labelled standings column. Before any
// game is complete, use an explicit state; only show the numeric record once it
// contains actual results.
export const formatSeasonRecord = (record: SeasonRecord) => {
  if (getSeasonRecordGamesPlayed(record) === 0) {
    return i18n.t("seasonRecord.notStarted", {
      ns: "ui",
      defaultValue: "Not started",
    });
  }

  return helpers.formatRecord({
    lost: record.lost ?? 0,
    otl: record.otl ?? 0,
    tied: record.tied ?? 0,
    won: record.won ?? 0,
  });
};
